import React from 'react';
import { motion } from 'framer-motion';
import { rsvpEmailTemplate, createMailtoLink } from '../utils/emailTemplates';

const Contact: React.FC = () => {
  return (
    <div className="bg-gradient-to-br from-cream via-white to-blush py-12 px-4" style={{ minHeight: '100vh', paddingBottom: '8rem' }}>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h1 className="page-header text-charcoal mb-4">
            Contact Us
          </h1>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-white/80 backdrop-blur-sm rounded-lg p-8 shadow-lg text-center"
          >
            <div className="bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4" style={{ width: '3rem', height: '3rem' }}>
              <svg className="text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ width: '1.5rem', height: '1.5rem' }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="section-header text-charcoal mb-3">
              General Questions
            </h2>
            <p className="body-text text-gray-light mb-4">
              Have a question about the wedding? Drop us an email!
            </p>
            <a 
              href="mailto:contact@catandri.ch"
              className="inline-block text-charcoal hover-text-gold transition-colors duration-300 button-text tracking-wider bg-transparent px-6 py-3"
            >
              contact@catandri.ch
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="bg-white/80 backdrop-blur-sm rounded-lg p-8 shadow-lg text-center"
            style={{ marginTop: '2rem' }}
          >
            <div className="bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4" style={{ width: '3rem', height: '3rem' }}>
              <svg className="text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ width: '1.5rem', height: '1.5rem' }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h2 className="section-header text-charcoal mb-3">
              RSVP
            </h2>
            <p className="body-text text-gray-light mb-4">
              Please click the link below to let us know if you can join us for our special day. We'd appreciate if you did this by 1st May, 2025.
            </p>
            <a
              href={createMailtoLink('contact@catandri.ch', rsvpEmailTemplate.subject, rsvpEmailTemplate.body)}
              className="inline-block text-charcoal hover-text-gold transition-colors duration-300 button-text tracking-wider bg-transparent px-6 py-3"
            >
              rsvp@catandri.ch
            </a>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;